import React, { Fragment, useEffect, useRef } from "react";
import { getFileExtensionIconClass } from "./utils";
import { GdkProgressBar } from "@gdk/progress-bar";

export default function FileUploadComplete({
    selectedFiles = () => [],
    fileUploadParameters,
    setFileUploadState,
    displayParameters,
    progress
}) {
    const progressBar = useRef();

    useEffect(() => {
        if (progress && !progressBar.current) {
            progressBar.current = new GdkProgressBar({
                "content": "#file-upload-progress",
                "setInitialValue": `${progress}`,
            });
        }

        progressBar.current?.setValue(progress);
    }, [progress]);

    return (
        <div className="drop doc-status-wrapper padding-bottom">
            <div className="font--center padding-top">
                <span className="success geico-icon icon-check-mark geico-icon--default geico-icon--informational" />
                {displayParameters.completeTopText}
            </div>
            {progress > 0 &&
                <div className="container-padding">
                    <div id="file-upload-progress" className="progress-wrapper">
                        <progress max="100" value={progress}>{progress}%</progress>
                        <label>{progress}%</label>
                    </div>
                </div>
            }
            {Array.from(selectedFiles).length > 0 &&
                <div className="doc-upload-status container-padding margin-bottom">
                    <div>
                        {displayParameters.completeHeader}
                    </div>
                    {displayParameters.showColumnHeaders &&
                        <div className="doc-labels padding-bottom hidden-sm hidden-md">
                            <div>File Name</div>
                            {fileUploadParameters.uploadCategories?.length > 0 && <div>Category</div>}
                        </div>
                    }
                    <div className="upload-container">
                        {Array.from(selectedFiles).map((file, index) => (
                            <Fragment key={file.name}>
                                {index > 0 && <hr />}
                                <div key={`${file.name}-selected-file-upload-container`}>
                                    <div className="doc-upload-files column">
                                        <span className={`img-icon ${getFileExtensionIconClass(file.name)} hidden-sm hidden-md`} />
                                    </div>
                                    <div className="status-name column col-lg-6">
                                        {file.name}
                                    </div>
                                    {fileUploadParameters.uploadCategories?.length > 0 &&
                                        <div className="status-category col-lg-6">
                                            {file.selectedUploadCategory}
                                        </div>
                                    }
                                    <div className="status-outcome col-lg-6">
                                        <span className="success geico-icon geico-icon--small icon-check-mark" />
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                </div>
            }
        </div>
    );
};
